module.exports = __webpack_public_path__ + "media/images/other-header-img-13dabaaf509c4b8d75ec5fe2d0cb2049.png";